import React, { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store';
import CoworkQueuedMessageItem from './CoworkQueuedMessageItem';
import { i18nService } from '../../services/i18n';

const CoworkQueuedMessagesBar: React.FC<{ sessionId: string | null }> = ({ sessionId }) => {
  const queued = useSelector((state: RootState) =>
    sessionId ? state.cowork.queuedMessagesBySession[sessionId] : undefined
  );
  const [expanded, setExpanded] = useState(false);

  if (!sessionId || !queued || queued.length === 0) return null;

  const summary = i18nService.t('coworkQueuedSummary').replace('{count}', String(queued.length));

  return (
    <div className="mb-2 overflow-hidden rounded-xl border dark:border-claude-darkBorder border-claude-border dark:bg-claude-darkSurface bg-claude-surface shadow-subtle">
      <button
        type="button"
        className="flex w-full items-center gap-2 px-3 py-2 text-left text-xs dark:text-claude-darkTextSecondary text-claude-textSecondary"
        onClick={() => setExpanded((value) => !value)}
        aria-expanded={expanded}
      >
        <span className="shrink-0 font-medium text-claude-accent">{summary}</span>
        <span className="min-w-0 flex-1 truncate" title={queued[0].preview}>
          {queued[0].preview || '…'}
        </span>
        <ChevronDownIcon className={`h-4 w-4 shrink-0 transition-transform ${expanded ? 'rotate-180' : ''}`} />
      </button>

      {expanded && (
        <div className="max-h-52 space-y-1.5 overflow-y-auto border-t px-2.5 py-2 dark:border-claude-darkBorder border-claude-border">
          {queued.map((item, index) => <CoworkQueuedMessageItem key={`${sessionId}:${item.id}`} item={item} index={index} />)}
        </div>
      )}
    </div>
  );
};

export default CoworkQueuedMessagesBar;
